import {
  IntegrationChannelType,
  IntegrationType,
  IntegrationViewFragment,
} from 'generated/graphql';

interface GetIsEditableIntegrationParams {
  channelType: IntegrationChannelType;
  integrationData: IntegrationViewFragment['data'] | undefined;
  integrationType: IntegrationType;
}

export const getIsEditableIntegration = ({
  channelType,
  integrationData,
  integrationType,
}: GetIsEditableIntegrationParams) => {
  if (integrationType === IntegrationType.Feedback) {
    return true; // Because all feedback integrations support adding/editing descriptions
  }

  switch (channelType) {
    case IntegrationChannelType.SurveyMonkey:
    case IntegrationChannelType.Typeform:
    case IntegrationChannelType.Salesforce:
    case IntegrationChannelType.Discord:
    case IntegrationChannelType.Slack:
    case IntegrationChannelType.Playstore: // TODO: Remove this once we remove feature flag for integration context
    case IntegrationChannelType.Reddit:
    case IntegrationChannelType.Qualtrics:
      return true;
    case IntegrationChannelType.FacebookPages:
      return integrationData
        ? !integrationData.facebookPages?.subscribedPage
        : true;
    default:
      return false;
  }
};
